import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FaArrowLeft,
  FaExternalLinkAlt,
  FaCheck,
  FaRobot,
  FaCoins,
  FaEthereum,
  FaTwitter,
  FaPlane,
  FaGraduationCap,
  FaHome,
  FaShoppingCart,
  FaComments,
  FaChartLine,
  FaTimes,
  FaChevronLeft,
  FaChevronRight
} from 'react-icons/fa';
import ProjectImage from '../components/ProjectImage';
import './PortfolioDetailPage.css';
import nafty1 from '../assets/nafty/modified_image.png';
import nafty2 from '../assets/nafty/nafty_main.png';
import nafty3 from '../assets/nafty/modified_image (2).png';
import nafty4 from '../assets/nafty/modified_image (4).png';
import nafty5 from '../assets/nafty/modified_image (5).png';
import nafty6 from '../assets/nafty/modified_image (6).png';
import nafty7 from '../assets/nafty/modified_image (7).png';
import nafty8 from '../assets/nafty/modified_image (8).png';
import destake1 from '../assets/destake/modified_image (3).png';
import destake2 from '../assets/destake/modified_image (9).png';
import destake3 from '../assets/destake/Screenshot (915).png';
import destake4 from '../assets/destake/Screenshot (916).png';
import destake5 from '../assets/destake/Screenshot (917).png';
import destake6 from '../assets/destake/Screenshot (918).png';
import destake7 from '../assets/destake/Screenshot (919).png';
import edumetrix1 from '../assets/edumetrix/modified_image (10).png';
import edumetrix2 from '../assets/edumetrix/modified_image (11).png';
import edumetrix3 from '../assets/edumetrix/modified_image (12).png';
import edumetrix4 from '../assets/edumetrix/modified_image (13).png';
import edumetrix5 from '../assets/edumetrix/modified_image (14).png';
import edumetrix6 from '../assets/edumetrix/modified_image (15).png';
import edumetrix7 from '../assets/edumetrix/modified_image (16).png';
import edumetrix8 from '../assets/edumetrix/modified_image (17).png';
import edumetrix9 from '../assets/edumetrix/modified_image (18).png';
import edumetrix10 from '../assets/edumetrix/modified_image (19).png';
import edumetrix11 from '../assets/edumetrix/modified_image (20).png';
import edumetrix12 from '../assets/edumetrix/modified_image (21).png';
import edumetrix13 from '../assets/edumetrix/modified_image (22).png';
import edumetrix14 from '../assets/edumetrix/modified_image (23).png';
import edumetrix15 from '../assets/edumetrix/modified_image (24).png';
import edumetrix16 from '../assets/edumetrix/modified_image (25).png';
import edumetrix17 from '../assets/edumetrix/modified_image (26).png';
import edumetrixMain from '../assets/edumetrix/modified_image (90).png';

import decrowd1 from '../assets/decrowd/modified_image (34).png';
import decrowd2 from '../assets/decrowd/modified_image (35).png';
import decrowd3 from '../assets/decrowd/modified_image (36).png';
import decrowd4 from '../assets/decrowd/modified_image (37).png';
import gojourney1 from '../assets/gouniquejourney/modified_image (38).png';
import gojourney2 from '../assets/gouniquejourney/modified_image (39).png';
import gojourney3 from '../assets/gouniquejourney/modified_image (40).png';
import gojourney4 from '../assets/gouniquejourney/modified_image (41).png';
import gojourney5 from '../assets/gouniquejourney/modified_image (42).png';
import gojourney6 from '../assets/gouniquejourney/modified_image (43).png';
import gojourney7 from '../assets/gouniquejourney/modified_image (44).png';
import gojourney8 from '../assets/gouniquejourney/modified_image (45).png';
import gojourney9 from '../assets/gouniquejourney/modified_image (46).png';
import gojourney10 from '../assets/gouniquejourney/modified_image (47).png';
import gojourney11 from '../assets/gouniquejourney/modified_image (48).png';
import gojourney12 from '../assets/gouniquejourney/modified_image (49).png';
import gojourney13 from '../assets/gouniquejourney/modified_image (50).png';
import gojourney14 from '../assets/gouniquejourney/modified_image (51).png';
import gojourney15 from '../assets/gouniquejourney/modified_image (52).png';
import gojourney16 from '../assets/gouniquejourney/modified_image (53).png';
import gojourney17 from '../assets/gouniquejourney/modified_image (54).png';
import gojourney18 from '../assets/gouniquejourney/modified_image (55).png';
import gojourney19 from '../assets/gouniquejourney/modified_image (56).png';
import gojourney20 from '../assets/gouniquejourney/modified_image (57).png';
import gojourney21 from '../assets/gouniquejourney/modified_image (58).png';
import gojourney22 from '../assets/gouniquejourney/modified_image (59).png';
import gojourney23 from '../assets/gouniquejourney/modified_image (60).png';
import gojourney24 from '../assets/gouniquejourney/modified_image (61).png';
import gojourney25 from '../assets/gouniquejourney/modified_image (62).png';
import gojourney26 from '../assets/gouniquejourney/modified_image (63).png';
import gojourney27 from '../assets/gouniquejourney/modified_image (64).png';
import gojourney28 from '../assets/gouniquejourney/modified_image (65).png';
import gojourney29 from '../assets/gouniquejourney/modified_image (66).png';
import gojourney30 from '../assets/gouniquejourney/modified_image (67).png';
import gojourney31 from '../assets/gouniquejourney/modified_image (68).png';
import gojourney32 from '../assets/gouniquejourney/modified_image (69).png';
import gojourney33 from '../assets/gouniquejourney/modified_image (70).png';
import gojourney34 from '../assets/gouniquejourney/modified_image (71).png';
import gojourney35 from '../assets/gouniquejourney/modified_image (72).png';
import gojourney36 from '../assets/gouniquejourney/modified_image (73).png';
import gojourney37 from '../assets/gouniquejourney/modified_image (74).png';
import gojourney38 from '../assets/gouniquejourney/modified_image (75).png';
import gojourney39 from '../assets/gouniquejourney/modified_image (76).png';
import gojourney40 from '../assets/gouniquejourney/modified_image (77).png';
import gojourney41 from '../assets/gouniquejourney/modified_image (78).png';
import gojourney42 from '../assets/gouniquejourney/modified_image (79).png';
import gojourney43 from '../assets/gouniquejourney/modified_image (80).png';
import gojourney44 from '../assets/gouniquejourney/modified_image (81).png';
import gojourney45 from '../assets/gouniquejourney/modified_image (82).png';
import gojourney46 from '../assets/gouniquejourney/modified_image (83).png';
import gojourney47 from '../assets/gouniquejourney/modified_image (84).png';
import gojourney48 from '../assets/gouniquejourney/modified_image (85).png';
import gojourney49 from '../assets/gouniquejourney/modified_image (86).png';
import gojourney50 from '../assets/gouniquejourney/modified_image (87).png';
import gojourney51 from '../assets/gouniquejourney/modified_image (88).png';
import linkedbricks1 from '../assets/linkedbricks/React App - Google Chrome 2024-03-19 22-43-54.mp4';
import linkedbricks2 from '../assets/linkedbricks/React App - Google Chrome 2024-03-19 22-47-26.mp4';
import linkedbricks3 from '../assets/linkedbricks/React App - Google Chrome 2024-03-20 00-13-14.mp4';
import nftmarketplace1 from '../assets/nftmarketplace/SaiNFT - NFT Marketplace - Google Chrome 2023-10-27 16-18-02.mp4';
import enteka1 from '../assets/enteka/modified_image - 2025-11-19T201633.637.png';
import enteka2 from '../assets/enteka/modified_image - 2025-11-19T201646.499.png';
import enteka3 from '../assets/enteka/modified_image - 2025-11-19T201843.229.png';
import enteka4 from '../assets/enteka/modified_image - 2025-11-19T201922.981.png';
import enteka5 from '../assets/enteka/modified_image - 2025-11-19T202051.698.png';
import enteka6 from '../assets/enteka/modified_image - 2025-11-19T202229.807.png';
import enteka7 from '../assets/enteka/modified_image (91).png';
import enteka8 from '../assets/enteka/modified_image (92).png';
import enteka9 from '../assets/enteka/modified_image (93).png';
import enteka10 from '../assets/enteka/modified_image (94).png';
import enteka11 from '../assets/enteka/modified_image (95).png';
import enteka12 from '../assets/enteka/modified_image (96).png';
import enteka13 from '../assets/enteka/modified_image (97).png';
import enteka14 from '../assets/enteka/modified_image (98).png';
import enteka15 from '../assets/enteka/modified_image (99).png';
import enteka16 from '../assets/enteka/modified_image (100).png';
import mingo1 from '../assets/mingo/modified_image - 2025-11-20T160637.607.png';
import mingo2 from '../assets/mingo/modified_image - 2025-11-20T160702.773.png';
import mingo3 from '../assets/mingo/modified_image - 2025-11-20T161022.637.png';
import mingo4 from '../assets/mingo/modified_image - 2025-11-20T161043.715.png';
import mingo5 from '../assets/mingo/modified_image - 2025-11-20T161136.751.png';
import blinkit1 from '../assets/blinkit/modified_image - 2025-11-21T191943.401.png';
import blinkit2 from '../assets/blinkit/modified_image - 2025-11-21T192917.579.png';
import blinkit3 from '../assets/blinkit/modified_image - 2025-11-21T192921.429.png';
import blinkit4 from '../assets/blinkit/modified_image - 2025-11-21T193140.905.png';
import blinkit5 from '../assets/blinkit/modified_image - 2025-11-21T193210.782.png';
import blinkit6 from '../assets/blinkit/modified_image - 2025-11-21T193316.686.png';
import blinkit7 from '../assets/blinkit/modified_image - 2025-11-21T193851.905.png';
import blinkit8 from '../assets/blinkit/Screenshot (924).png';
import blinkit9 from '../assets/blinkit/Screenshot (925).png';
import blinkit10 from '../assets/blinkit/Screenshot (926).png';
import jobiva1 from '../assets/jobiva/modified_image - 2025-11-24T192219.674.png';
import learngenix1 from '../assets/learngenix/modified_image - 2025-11-26T171159.475.png';

const PortfolioDetailPage = () => {
  const { id } = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const projectsData = {
    1: {
      title: 'DeStake - DeFi Staking Application',
      client: 'DeFi Project',
      year: '2024',
      category: 'Blockchain Development',
      icon: FaCoins,
      description: 'Engineered DeStake, a decentralized application for ERC20 token staking, generating per-second rewards based on stake amount and duration through smart contract automation.',
      challenge: 'Creating a secure and efficient staking platform that calculates rewards per second based on stake amount and duration, while ensuring smart contract security and optimal gas efficiency for users.',
      solution: 'Developed smart contracts in Solidity with automated reward distribution mechanisms. Built a modern React frontend with Vite for optimal performance, integrated Ethers.js for blockchain interactions, and implemented real-time reward tracking.',
      results: [
        'Automated per-second reward calculation',
        'Gas-optimized smart contracts',
        'Secure staking mechanism with no vulnerabilities',
        'Modern and intuitive user interface',
        'Real-time reward tracking and updates',
        'Seamless wallet integration'
      ],
      features: [
        'ERC20 token staking',
        'Per-second reward calculation',
        'Automated reward distribution via smart contracts',
        'Stake amount and duration tracking',
        'Real-time balance updates',
        'Withdraw staked tokens anytime',
        'Modern React UI with Vite',
        'MetaMask wallet integration'
      ],
      technologies: ['React', 'Vite', 'Solidity', 'Ethers.js', 'Ethereum', 'Smart Contracts', 'Web3'],
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      images: [destake1, destake2, destake3, destake4, destake5, destake6, destake7],
      demoLink: 'https://destake-defi-app.vercel.app/',
      githubLink: '',
      testimonial: {
        text: 'A comprehensive DeFi staking solution with automated rewards and a clean, user-friendly interface.',
        author: 'DeFi Team',
        position: 'Project Lead'
      }
    },
    2: {
      title: 'Nafty - Web3 + AI Social Media',
      client: 'Web3 Social Platform',
      year: '2024',
      category: 'Blockchain & AI Development',
      icon: FaRobot,
      description: 'Created a blockchain + AI social media app for minting, buying, selling, and sharing NFTs (ERC721), with social features like likes & comments. Integrated Gemini API for generating content.',
      challenge: 'Building a comprehensive Web3 social platform that combines NFT functionality with traditional social media features while integrating AI for content generation. Needed to ensure secure smart contracts and seamless user experience.',
      solution: 'Developed ERC721 NFT smart contracts using Solidity and Remix IDE. Built a React frontend with Web3.js integration for blockchain interactions. Integrated Google Gemini API for AI-powered content generation. Used Tailwind CSS for modern, responsive design.',
      results: [
        'Full NFT marketplace functionality',
        'AI-powered content generation using Gemini API',
        'Social engagement with likes and comments',
        'Secure ERC721 smart contracts',
        'Modern UI with Tailwind CSS',
        'Seamless Web3 wallet integration'
      ],
      features: [
        'Mint custom NFTs (ERC721)',
        'Buy and sell NFTs on marketplace',
        'Social feed for sharing NFTs',
        'Like and comment on NFT posts',
        'AI content generation with Gemini API',
        'User profiles and galleries',
        'Ethereum blockchain integration',
        'MetaMask wallet connectivity'
      ],
      technologies: ['React', 'Solidity', 'Web3.js', 'Ethereum', 'Remix IDE', 'Tailwind CSS', 'Gemini API', 'ERC721'],
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      images: [nafty1, nafty2, nafty3, nafty4, nafty5, nafty6, nafty7, nafty8],
      demoLink: 'https://nafty-dapp.vercel.app/',
      githubLink: '',
      testimonial: {
        text: 'Innovative fusion of blockchain, AI, and social media that creates a unique user experience.',
        author: 'Web3 Team',
        position: 'Product Manager'
      }
    },
     3: {
      title: 'Go Unique Journeys',
      client: 'UK Travel Agency',
      year: '2024',
      category: 'Web Development',
      icon: FaPlane,
      description: 'Led a team of 3–4 developers to deliver a full-featured travel booking system for client in UK with user, employee, and admin dashboards, and a custom CMS for content and booking management.',
      challenge: 'Building a comprehensive travel booking platform that handles complex booking workflows, integrates with multiple service providers, and provides role-specific dashboards for different user types while ensuring real-time updates and high performance.',
      solution: 'Led team development using React and Next.js for frontend with Redux for state management. Built secure RESTful APIs with Node.js and Express, MongoDB for data storage. Deployed on GoDaddy VPS with nginx. Implemented chatbot for customer support and real-time booking updates.',
      results: [
        'Successfully led team of 3-4 developers',
        'Real-time booking updates implemented',
        'Chatbot integration for customer support',
        'Custom CMS for content management',
        'VPS deployment with nginx optimization',
        'High performance and scalability achieved'
      ],
      features: [
        'User, employee, and admin dashboards',
        'Custom CMS for content management',
        'Booking management system',
        'Real-time booking updates',
        'Integrated chatbot support',
        'RESTful API architecture',
        'Secure authentication and authorization',
        'Responsive modern UI'
      ],
      technologies: ['React', 'Next.js', 'Node.js', 'Express', 'MongoDB', 'Redux', 'nginx', 'GoDaddy VPS'],
      gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      images: [gojourney1, gojourney2, gojourney3, gojourney4, gojourney5, gojourney6, gojourney7, gojourney8, gojourney9, gojourney10, gojourney11, gojourney12, gojourney13, gojourney14, gojourney15, gojourney16, gojourney17, gojourney18, gojourney19, gojourney20, gojourney21, gojourney22, gojourney23, gojourney24, gojourney25, gojourney26, gojourney27, gojourney28, gojourney29, gojourney30, gojourney31, gojourney32, gojourney33, gojourney34, gojourney35, gojourney36, gojourney37, gojourney38, gojourney39, gojourney40, gojourney41, gojourney42, gojourney43, gojourney44, gojourney45, gojourney46, gojourney47, gojourney48, gojourney49, gojourney50, gojourney51],
      demoLink: 'https://gouniquejourneys.co.uk/',
      githubLink: '',
      testimonial: {
        text: 'Professional travel booking solution that streamlined our operations and improved customer satisfaction significantly.',
        author: 'Travel Agency Director',
        position: 'Managing Director, UK'
      }
    },
    4: {
      title: 'EduMetrix Limited',
      client: 'UK EdTech',
      year: '2024',
      category: 'Web Development',
      icon: FaGraduationCap,
      description: 'Developed a full-fledged learning management system (LMS) for client in UK with role-based portals for admins, teachers, and students, utilizing the MERN stack.',
      challenge: 'Creating a comprehensive LMS that handles complex educational workflows including live classes, attendance tracking, homework management, and fee processing while providing seamless real-time communication and role-specific functionality.',
      solution: 'Built using MERN stack with Socket.io for real-time features. Integrated Google Meet API for live classes and Calendar API for scheduling. Implemented role-based access control with separate interfaces for admins, teachers, and students. Added real-time messaging and notifications.',
      results: [
        'Google Meet integration for live classes',
        'Real-time messaging with Socket.io',
        'Automated attendance tracking',
        'Homework and assignment management',
        'Fee and salary tracking system',
        'Lesson planning tools for teachers'
      ],
      features: [
        'Role-based portals (admin/teacher/student)',
        'Google Meet integration for live classes',
        'Calendar API for scheduling',
        'Class management system',
        'Attendance tracking',
        'Homework and assignment management',
        'Lesson planning tools',
        'Fee and salary tracking',
        'Real-time messaging and notifications',
        'Student performance analytics'
      ],
      technologies: ['MongoDB', 'Express', 'React', 'Node.js', 'Socket.io', 'Google Meet API', 'Google Calendar API', 'JWT'],
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      images: [edumetrixMain, edumetrix1, edumetrix2, edumetrix3, edumetrix4, edumetrix5, edumetrix6, edumetrix7, edumetrix8, edumetrix9, edumetrix10, edumetrix11, edumetrix12, edumetrix13, edumetrix14, edumetrix15, edumetrix16, edumetrix17],
      demoLink: 'https://www.edumetrix.uk/',
      githubLink: '',
      testimonial: {
        text: 'Comprehensive LMS that transformed our educational delivery. The live class integration works flawlessly.',
        author: 'Educational Director',
        position: 'Director, EduMetrix Limited'
      }
    },
    5: {
      title: 'Linked Bricks',
      client: 'UK Real Estate',
      year: '2024',
      category: 'Web Development',
      icon: FaHome,
      description: 'Built dynamic real estate platforms for client in the UK with advanced search, map integration, and user dashboard. Worked as Founding Fullstack Engineer.',
      challenge: 'Developing a feature-rich real estate platform with advanced property search, interactive maps, real-time messaging between buyers and sellers, and seamless payment processing while converting complex Figma designs into pixel-perfect responsive UI.',
      solution: 'Developed RESTful APIs using Node.js, Express, and MongoDB. Built React frontend with Redux for state management and Axios for API communication. Integrated Google Maps API for property locations, Stripe for payments, and Socket.io for real-time messaging. Converted Figma designs into responsive UI.',
      results: [
        'Advanced property search functionality',
        'Google Maps integration',
        'Stripe payment processing',
        'Real-time messaging with Socket.io',
        'Pixel-perfect Figma to code conversion',
        'Responsive design across all devices'
      ],
      features: [
        'Advanced property search and filters',
        'Interactive Google Maps integration',
        'User dashboard for buyers and sellers',
        'Real-time messaging between users',
        'Stripe payment integration',
        'Property listing management',
        'Saved searches and favorites',
        'Property comparison tools',
        'Responsive pixel-perfect UI'
      ],
      technologies: ['React', 'Redux', 'Node.js', 'Express', 'MongoDB', 'Google Maps API', 'Stripe', 'Socket.io', 'Axios'],
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      videos: [linkedbricks1, linkedbricks2, linkedbricks3],
      demoLink: '',
      githubLink: '',
      testimonial: {
        text: 'Outstanding real estate platform with excellent user experience. The map integration and real-time messaging are game-changers.',
        author: 'Real Estate Manager',
        position: 'Operations Manager, UK'
      }
    },
    6: {
      title: 'DeCrowd - Decentralized Crowdfunding',
      client: 'Crowdfunding Platform',
      year: '2024',
      category: 'Blockchain Development',
      icon: FaEthereum,
      description: 'Built a blockchain-based crowdfunding platform on Ethereum for campaign creation, live contribution tracking, and campaign history with DAO governance and user profiles.',
      challenge: 'Creating a transparent and trustless crowdfunding platform that ensures campaign creators cannot misuse funds while providing real-time tracking and DAO governance for community decision-making.',
      solution: 'Developed smart contracts using Solidity with Thirdweb for deployment and management. Built React frontend with Context API for state management. Implemented DAO governance mechanisms and user profile system. Styled with Tailwind CSS for a modern interface.',
      results: [
        'Transparent and trustless crowdfunding',
        'DAO governance for community decisions',
        'Real-time contribution tracking',
        'Complete campaign history on blockchain',
        'Secure fund management',
        'User profiles and verification'
      ],
      features: [
        'Create and manage campaigns',
        'Live contribution tracking',
        'DAO governance system',
        'User profiles and history',
        'Smart contract fund management',
        'Campaign milestone tracking',
        'Transparent transaction history',
        'Ethereum blockchain integration'
      ],
      technologies: ['Solidity', 'Thirdweb', 'React', 'Context API', 'Tailwind CSS', 'Ethereum', 'Smart Contracts', 'Web3'],
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      images: [decrowd1, decrowd2, decrowd3, decrowd4, ],
      demoLink: 'https://decrowd.netlify.app/',
      githubLink: '',
      testimonial: {
        text: 'A trustless crowdfunding solution with complete transparency that empowers both creators and backers.',
        author: 'Crowdfunding Team',
        position: 'Platform Lead'
      }
    },

    7: {
      title: 'Enteka Shop',
      client: 'E-commerce',
      year: '2024',
      category: 'Web Development',
      icon: FaShoppingCart,
      description: 'Developed full-featured online stores with payment integration, user dashboards, and admin dashboard using the MERN stack, Next.js & Redux.',
      challenge: 'Building a complete e-commerce solution with comprehensive product management, secure payment processing, user accounts, and powerful admin tools while ensuring optimal performance and user experience.',
      solution: 'Built using MERN stack with Next.js for SEO optimization and server-side rendering. Implemented Redux for state management. Integrated payment gateways for secure transactions. Created user dashboard for order tracking and admin dashboard for complete store management.',
      results: [
        'Full e-commerce functionality',
        'Secure payment gateway integration',
        'User dashboard with order tracking',
        'Comprehensive admin dashboard',
        'Next.js for improved SEO',
        'Redux for efficient state management'
      ],
      features: [
        'Complete product catalog management',
        'Shopping cart and checkout',
        'Payment gateway integration',
        'User registration and authentication',
        'User dashboard with order history',
        'Admin dashboard for store management',
        'Inventory management',
        'Order processing and tracking',
        'Product reviews and ratings',
        'Discount and coupon system'
      ],
      technologies: ['MongoDB', 'Express', 'React', 'Node.js', 'Next.js', 'Redux', 'Payment Gateway', 'JWT'],
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      images: [enteka1, enteka2, enteka3, enteka4, enteka5, enteka6, enteka7, enteka8, enteka9, enteka10, enteka11, enteka12, enteka13, enteka14, enteka15, enteka16],
      demoLink: 'https://enteka-shop-oydi.onrender.com/',
      githubLink: '',
      testimonial: {
        text: 'Professional e-commerce platform with all the features we needed. The admin dashboard makes store management effortless.',
        author: 'Store Owner',
        position: 'Founder, Enteka Shop'
      }
    },
    8: {
      title: 'NFT Marketplace',
      client: 'Web3 Platform',
      year: '2024',
      category: 'Blockchain Development',
      icon: FaEthereum,
      description: 'Built a decentralized NFT marketplace using React.js, Redux, Web3.js, and Material UI, with Metamask authentication and Ethereum smart contracts integration.',
      challenge: 'Creating a decentralized NFT marketplace that seamlessly integrates with Ethereum blockchain, provides secure Metamask authentication, and enables real-time blockchain interactions while maintaining an intuitive user interface.',
      solution: 'Developed using React.js with Redux for state management and Material UI for design. Integrated Web3.js for blockchain interactions and Ethereum smart contracts via GraphQL NFT APIs. Implemented Metamask authentication for secure wallet connectivity. Used Firestore for off-chain data management.',
      results: [
        'Seamless Metamask wallet integration',
        'Smart contract integration via Web3.js',
        'GraphQL NFT APIs for data fetching',
        'Real-time blockchain interactions',
        'Responsive Material UI design',
        'Secure user authentication'
      ],
      features: [
        'NFT browsing and discovery',
        'Buy and sell NFTs',
        'Metamask wallet authentication',
        'Ethereum smart contract integration',
        'GraphQL NFT APIs',
        'Real-time blockchain updates',
        'User profiles and collections',
        'Transaction history',
        'Firestore database integration'
      ],
      technologies: ['React', 'Redux', 'Web3.js', 'Ethereum', 'Material UI', 'Firestore', 'GraphQL', 'Metamask', 'Smart Contracts'],
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      videos: [nftmarketplace1],
      demoLink: 'https://sainftmarketkplace.xyz/',
      githubLink: '',
      testimonial: {
        text: 'Excellent NFT marketplace with smooth Web3 integration. The user experience is outstanding.',
        author: 'Web3 Developer',
        position: 'Platform Lead'
      }
    },
    9: {
      title: 'Real-time Encrypted Chat',
      client: 'Chat Application',
      year: '2024',
      category: 'Web Development',
      icon: FaComments,
      description: 'Developed a real-time & end-to-end encrypted group chat application with room management, built using React, TypeScript, Redux, Node.js, MySQL, Socket.io, and AES-256 encryption.',
      challenge: 'Building a secure chat application with military-grade end-to-end encryption while maintaining real-time performance, group chat functionality, and comprehensive room management features.',
      solution: 'Built using React with TypeScript for type safety and Redux for state management. Developed Node.js backend with Express and MySQL database. Implemented Socket.io for real-time messaging and Crypto AES-256 for end-to-end encryption. Integrated AWS S3 for file storage.',
      results: [
        'End-to-end AES-256 encryption',
        'Real-time messaging with Socket.io',
        'Comprehensive room management',
        'AWS S3 file storage integration',
        'TypeScript for type safety',
        'MySQL database for data persistence'
      ],
      features: [
        'Real-time group chat',
        'End-to-end AES-256 encryption',
        'Create, update, delete rooms',
        'Add and remove room members',
        'Room administration controls',
        'File sharing with AWS S3',
        'Message history',
        'JWT authentication',
        'User presence indicators',
        'Typing indicators'
      ],
      technologies: ['React', 'TypeScript', 'Redux', 'Node.js', 'Express', 'MySQL', 'Socket.io', 'AES-256', 'AWS S3', 'JWT'],
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      images: [mingo1, mingo2, mingo3, mingo4, mingo5],
      demoLink: 'https://mingo-chatapp.web.app/',
      githubLink: '',
      testimonial: {
        text: 'Highly secure chat application with excellent real-time performance. The encryption gives us peace of mind.',
        author: 'Security Team',
        position: 'Technical Lead'
      }
    },
    
    10: {
      title: 'E-commerce Platform',
      client: 'Online Store',
      year: '2024',
      category: 'Web Development',
      icon: FaShoppingCart,
      description: 'Developed an e-commerce platform using React, Context API, Node.js, Firebase, Stripe, Razorpay with features like shopping cart, product reviews, and advanced search.',
      challenge: 'Building a feature-rich e-commerce platform with dual payment gateway integration, Firebase authentication, advanced product features, and optimized performance through lazy loading while maintaining excellent user experience.',
      solution: 'Built using React with Context API for state management. Developed Node.js/Express backend. Integrated Firebase for authentication and Stripe/Razorpay for dual payment options. Implemented React lazy loading for performance optimization. Used Material UI for modern design with features like image magnification, pagination, and advanced filtering.',
      results: [
        'Dual payment gateway integration',
        'Firebase secure authentication',
        'React lazy loading optimization',
        'Advanced product features',
        'Image magnification and zoom',
        'Comprehensive search and filtering'
      ],
      features: [
        'Shopping cart and checkout',
        'Stripe and Razorpay payment options',
        'Firebase authentication',
        'Product reviews and ratings',
        'Image magnification feature',
        'Advanced search functionality',
        'Product filtering and sorting',
        'Pagination for product listings',
        'React lazy loading for performance',
        'Material UI responsive design'
      ],
      technologies: ['React', 'Context API', 'Node.js', 'Express', 'Firebase', 'Stripe', 'Razorpay', 'Material UI', 'React Lazy Loading'],
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      images: [blinkit1, blinkit2, blinkit3, blinkit4, blinkit5, blinkit6, blinkit7, blinkit8, blinkit9, blinkit10],
      demoLink: 'https://blink-it-ecommerce.netlify.app/',
      githubLink: '',
      testimonial: {
        text: 'Feature-rich e-commerce platform with excellent payment options and user experience. The lazy loading makes it incredibly fast.',
        author: 'Store Manager',
        position: 'Operations Lead'
      }
    },
        
    11: {
      title: 'Jobiva International',
      client: 'UK Recruitment Agency',
      year: '2024',
      category: 'Web Development',
      icon: FaGraduationCap,
      description: 'Jobiva International is a healthcare recruitment landing page website built using React, Next JS, Material UI & CSS.',
      challenge: 'Creating a professional healthcare recruitment landing page that effectively showcases services, builds trust, and converts visitors into leads while providing an excellent user experience across all devices.',
      solution: 'Built using React and Next.js for optimal performance and SEO. Designed with Material UI and custom CSS for a modern, professional look. Implemented responsive design and optimized for healthcare industry recruitment needs.',
      results: [
        'Professional healthcare recruitment landing page',
        'Modern and responsive design',
        'SEO-optimized for healthcare recruitment',
        'Fast loading performance with Next.js',
        'Material UI component integration',
        'Enhanced user engagement and conversions'
      ],
      features: [
        'Healthcare recruitment services showcase',
        'Responsive design for all devices',
        'Modern Material UI components',
        'Next.js for optimal performance and SEO',
        'Custom CSS styling',
        'Professional service presentation',
        'Contact and inquiry forms',
        'Mobile-first approach',
        'Clean and intuitive navigation',
        'Healthcare industry focus'
      ],
      technologies: ['React', 'Next.js', 'Material UI', 'CSS'],
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      images: [jobiva1],
      demoLink: 'https://jobivainternational.com/',
      githubLink: '',
      testimonial: {
        text: 'Professional healthcare recruitment landing page that effectively showcases our services and drives quality leads.',
        author: 'HR Director',
        position: 'Jobiva International'
      }
    },
    12: {
      title: 'Learngenix',
      client: 'EdTech Platform',
      year: '2024',
      category: 'Web Development',
      icon: FaGraduationCap,
      description: 'Developed an AI-powered educational course landing page website utilizing React, Next.js, and CSS. The platform provides an engaging user experience for showcasing educational courses with modern design and responsive layouts.',
      challenge: 'Creating an engaging educational landing page that effectively showcases AI-powered course offerings while maintaining a modern aesthetic and ensuring optimal performance across all devices.',
      solution: 'Built using React and Next.js for server-side rendering and optimal performance. Implemented modern CSS techniques for responsive design and integrated AI-powered features to enhance the educational experience. Focused on user engagement and conversion optimization.',
      results: [
        'AI-powered content presentation',
        'Modern responsive design',
        'Fast loading with Next.js',
        'Enhanced user engagement',
        'Optimal performance across devices',
        'Improved course discovery experience'
      ],
      features: [
        'AI-powered course recommendations',
        'Modern educational landing page',
        'Responsive design for all devices',
        'Next.js for optimal performance and SEO',
        'Custom CSS styling',
        'Course showcase and presentation',
        'Engaging user interface',
        'Mobile-first approach',
        'Fast page loading',
        'Educational content focus'
      ],
      technologies: ['React', 'Next.js', 'CSS', 'AI'],
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      images: [learngenix1],
      demoLink: 'https://learngenix.vercel.app/',
      githubLink: '',
      testimonial: {
        text: 'Innovative educational platform with AI integration that creates an engaging learning experience.',
        author: 'Education Team',
        position: 'Platform Director'
      }
    },
    13: {
      title: 'DVote - Decentralized Voting Platform',
      client: 'Voting Platform',
      year: '2024',
      category: 'Blockchain Development',
      icon: FaCheck,
      description: 'Built a secure Ethereum voting platform with DAO governance and a custom ERC-20 token; designed tokenomics with 0.001 ETH candidate staking and 50% reward distribution.',
      challenge: 'Creating a transparent and tamper-proof voting system with custom tokenomics that incentivizes participation while preventing fraud. Needed to implement DAO governance and ensure voting integrity.',
      solution: 'Developed smart contracts using Solidity and Hardhat for testing and deployment. Created a custom ERC-20 token with specific tokenomics. Built Next.js frontend with Web3.js integration. Used Remix IDE for smart contract development and Tailwind CSS for styling.',
      results: [
        'Secure and transparent voting on Ethereum',
        'DAO governance implementation',
        'Custom ERC-20 token with tokenomics',
        '0.001 ETH candidate staking mechanism',
        '50% reward distribution to voters',
        'Tamper-proof vote recording'
      ],
      features: [
        'Decentralized voting system',
        'DAO governance mechanisms',
        'Custom ERC-20 token',
        'Candidate staking (0.001 ETH)',
        'Voter reward distribution (50%)',
        'Transparent vote counting',
        'Secure ballot submission',
        'Real-time results tracking'
      ],
      technologies: ['Solidity', 'Hardhat', 'ERC-20', 'Next.js', 'Web3.js', 'Remix IDE', 'Tailwind CSS', 'Ethereum'],
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      demoLink: '',
      githubLink: '',
      testimonial: {
        text: 'Democratic and transparent voting powered by blockchain technology with innovative tokenomics.',
        author: 'Voting Team',
        position: 'Platform Director'
      }
    },
    14: {
      title: 'TweetCrypt - AI Virality Predictor',
      client: 'Chrome Extension',
      year: '2024',
      category: 'AI & Blockchain',
      icon: FaTwitter,
      description: 'Developed a Chrome extension with AI/ML and blockchain on the MERN stack, enabling users to bet on tweet virality with Ethereum-based rewards. Built ML models with 85% accuracy.',
      challenge: 'Creating a Chrome extension that accurately predicts tweet virality using machine learning while integrating blockchain for betting mechanisms and reward distribution. Needed to achieve high prediction accuracy and seamless user experience.',
      solution: 'Built using MERN stack (MongoDB, Express, React, Node.js) for full-stack development. Developed machine learning models with 85% prediction accuracy. Integrated Ethereum smart contracts for betting and reward distribution. Packaged as a Chrome extension for easy access.',
      results: [
        '85% ML prediction accuracy achieved',
        'Ethereum-based betting system',
        'Smart contract reward distribution',
        'Chrome browser integration',
        'Real-time virality predictions',
        'Secure blockchain transactions'
      ],
      features: [
        'Tweet virality prediction using ML',
        'AI models with 85% accuracy',
        'Ethereum-based betting system',
        'Smart contract rewards',
        'Chrome extension interface',
        'Real-time tweet analysis',
        'User betting history',
        'Reward tracking and withdrawal'
      ],
      technologies: ['MERN Stack', 'Machine Learning', 'Ethereum', 'Chrome Extension', 'Smart Contracts', 'Python', 'TensorFlow'],
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      demoLink: '',
      githubLink: '',
      testimonial: {
        text: 'Innovative combination of AI predictions and blockchain rewards that gamifies social media engagement.',
        author: 'Extension Team',
        position: 'Product Lead'
      }
    },
    15: {
      title: 'Expense Tracker',
      client: 'Finance Management',
      year: '2024',
      category: 'Web Development',
      icon: FaChartLine,
      description: 'Developed a full-stack expense management system using React.js, Redux, Node.js, MongoDB, Razorpay, AWS S3, Chart.js, implementing premium accounts and data visualization.',
      challenge: 'Creating a comprehensive expense tracking system with premium subscription model, payment processing, data visualization, and cloud-based export capabilities while ensuring secure user authentication and data management.',
      solution: 'Built with React.js frontend using Redux/Redux Thunk for state management. Developed Node.js/Express backend with MongoDB database. Integrated Razorpay for premium account purchases. Used Chart.js for data visualization and AWS S3 for CSV export functionality. Implemented JWT for secure authentication.',
      results: [
        'Razorpay payment integration',
        'Premium account system',
        'Data visualization with Chart.js',
        'AWS S3 CSV export functionality',
        'Secure JWT authentication',
        'Income and balance tracking'
      ],
      features: [
        'Expense tracking and categorization',
        'Income and balance management',
        'Premium account purchases via Razorpay',
        'Data visualization with charts',
        'AWS-powered CSV export',
        'Expense analytics and insights',
        'Budget planning tools',
        'Recurring expense tracking',
        'Secure user authentication',
        'Material UI design'
      ],
      technologies: ['React', 'Redux', 'Redux Thunk', 'Node.js', 'Express', 'MongoDB', 'Razorpay', 'AWS S3', 'JWT', 'Chart.js', 'Material UI'],
      gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      demoLink: '',
      githubLink: '',
      testimonial: {
        text: 'Comprehensive expense tracker that helps manage finances effectively. The premium features are worth every penny.',
        author: 'Finance User',
        position: 'Personal Finance Enthusiast'
      }
    },

  };

  const project = projectsData[id] || projectsData[1];

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const nextImage = () => {
    if (project.images && currentImageIndex < project.images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    } else if (project.images) {
      setCurrentImageIndex(0);
    }
  };

  const prevImage = () => {
    if (project.images && currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    } else if (project.images) {
      setCurrentImageIndex(project.images.length - 1);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!modalOpen) return;

      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowRight') {
        if (project.images && currentImageIndex < project.images.length - 1) {
          setCurrentImageIndex(currentImageIndex + 1);
        } else if (project.images) {
          setCurrentImageIndex(0);
        }
      } else if (e.key === 'ArrowLeft') {
        if (project.images && currentImageIndex > 0) {
          setCurrentImageIndex(currentImageIndex - 1);
        } else if (project.images) {
          setCurrentImageIndex(project.images.length - 1);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalOpen, currentImageIndex, project.images]);

  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [modalOpen]);

  return (
    <div className="portfolio-detail-page">
      <section className="detail-hero" style={{ background: project.gradient }}>
        <div className="detail-hero-content">
          <Link to="/portfolio" className="back-link">
            <FaArrowLeft /> Back to Portfolio
          </Link>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="project-header">
              <div>
                <span className="project-category">{project.category}</span>
                <h1>{project.title}</h1>
                <div className="project-meta-detail">
                  <span>Client: {project.client}</span>
                  <span>•</span>
                  <span>Year: {project.year}</span>
                </div>
              </div>
              <div className="project-actions">
                {project.demoLink && (
                  <motion.a
                    href={project.demoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="action-btn"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <FaExternalLinkAlt /> Live Demo
                  </motion.a>
                )}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="detail-image-section">
        <div className="detail-image-container">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <ProjectImage
              gradient={project.gradient}
              icon={project.icon}
              title={project.title}
              images={project.images}
              videos={project.videos}
            />
          </motion.div>
        </div>
      </section>

      {project.images && project.images.length > 1 && (
        <section className="detail-gallery-section">
          <div className="detail-gallery-container">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Project Gallery
            </motion.h2>
            <div className="gallery-grid">
              {project.images.map((image, index) => (
                <motion.div
                  key={index}
                  className="gallery-item"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => openModal(index)}
                >
                  <img src={image} alt={`${project.title} - Screenshot ${index + 1}`} />
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      )}

      {project.videos && project.videos.length > 0 && (
        <section className="detail-gallery-section">
          <div className="detail-gallery-container">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Project Videos
            </motion.h2>
            <div className="gallery-grid">
              {project.videos.map((video, index) => (
                <motion.div
                  key={index}
                  className="gallery-item"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                >
                  <video
                    src={video}
                    controls
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="detail-content">
        <div className="detail-container">
          <div className="detail-main">
            <motion.div
              className="detail-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2>Project Overview</h2>
              <p className="overview-text">{project.description}</p>
            </motion.div>

            <motion.div
              className="detail-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h2>The Challenge</h2>
              <p>{project.challenge}</p>
            </motion.div>

            <motion.div
              className="detail-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h2>Our Solution</h2>
              <p>{project.solution}</p>
            </motion.div>

            <motion.div
              className="detail-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <h2>Key Features</h2>
              <div className="features-grid">
                {project.features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <FaCheck className="check-icon" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </motion.div>

            <motion.div
              className="detail-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h2>Results & Impact</h2>
              <div className="results-grid">
                {project.results.map((result, index) => (
                  <div key={index} className="result-card">
                    <FaCheck className="result-icon" />
                    <p>{result}</p>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>

          <div className="detail-sidebar">
            <motion.div
              className="sidebar-card"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h3>Technologies Used</h3>
              <div className="tech-list">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="tech-badge">{tech}</span>
                ))}
              </div>
            </motion.div>

            <motion.div
              className="sidebar-card cta-card"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h3>Interested in a Similar Project?</h3>
              <p>Let's discuss how we can help you achieve your goals</p>
              <Link to="/contact">
                <motion.button
                  className="sidebar-cta-btn"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Get in Touch
                </motion.button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="related-projects">
        <div className="related-container">
          <h2>More Projects</h2>
          <p>Check out our other successful projects</p>
          <Link to="/portfolio" className="view-all-btn">
            View All Projects
          </Link>
        </div>
      </section>

      <AnimatePresence>
        {modalOpen && project.images && (
          <motion.div
            className="image-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div
              className="image-modal-content"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close-btn" onClick={closeModal}>
                <FaTimes />
              </button>

              <button className="modal-nav-btn modal-prev-btn" onClick={prevImage}>
                <FaChevronLeft />
              </button>

              <div className="modal-image-container">
                <img
                  src={project.images[currentImageIndex]}
                  alt={`${project.title} - Screenshot ${currentImageIndex + 1}`}
                />
                <div className="modal-image-counter">
                  {currentImageIndex + 1} / {project.images.length}
                </div>
              </div>

              <button className="modal-nav-btn modal-next-btn" onClick={nextImage}>
                <FaChevronRight />
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PortfolioDetailPage;
